/**
 * Extra Algolia parameters for product searches.
 *
 * Algolia requires every word of a query to match, so a customer pasting a
 * product name off a quote or an email gets a blank page for something we
 * actually sell. Verified against the live index: "pg2 pedestrian guardrail
 * 2.0m wide sight top - bs7818 galv" returns nothing by default, and returns
 * the real product (SKU WEB-9092) with `lastWords`. Trailing words are only
 * dropped when the query would otherwise return nothing, so exact queries are
 * unaffected.
 *
 * Products only. Relaxing matching on the category and pages indices produced
 * actively wrong results in testing - "garden screening" started returning a
 * "Polyamide Garden Gate Kit" - and a blank page beats a confidently wrong
 * one.
 */
export const PRODUCT_SEARCH_PARAMS = {
  removeWordsIfNoResults: "lastWords",
}
